import axios from './axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export function useGetRecentWiresBySeries() {
  return useAxios({
    url: '/api/v1/series/wires/recent',
    method: 'GET',
  });
}

export function listAllSeries() {
  return axios.get('/api/v1/series');
}
